import {Component, Input, OnInit} from '@angular/core';
import {ThemePalette} from "@angular/material/core";
import {Observable} from "rxjs";
import {ApiService, ChatbotDef, RagSessionDef} from "../../../services/api.service";
import {ActivatedRoute, Router, RouterLink} from "@angular/router";
import {ActionsContainerComponent} from "../../../core/actions-container/actions-container.component";
import {BackButtonComponent} from "../../../core/back-button/back-button.component";
import {DataPreviewComponent} from "../../../core/data-preview/data-preview.component";
import {DeleteButtonComponent} from "../../../core/delete-button/delete-button.component";
import {LoaderContainerComponent} from "../../../core/loader-container/loader-container.component";
import {ManageButtonComponent} from "../../../core/manage-button/manage-button.component";
import {MatButtonModule} from "@angular/material/button";
import {JsonPipe, NgClass, NgForOf, NgIf} from "@angular/common";
import {RouteContainerComponent} from "../../../core/route-container/route-container.component";
import {MatIconModule} from "@angular/material/icon";
import {TenantIdTagComponent} from "../../tenants/tenant-id-tag/tenant-id-tag.component";

@Component({
  selector: 'app-chatbot-preview',
  standalone: true,
  imports: [
    ActionsContainerComponent,
    BackButtonComponent,
    DataPreviewComponent,
    DeleteButtonComponent,
    LoaderContainerComponent,
    ManageButtonComponent,
    MatButtonModule,
    NgIf,
    RouteContainerComponent,
    RouterLink,
    NgForOf,
    JsonPipe,
    NgClass,
    MatIconModule,
    TenantIdTagComponent
  ],
  templateUrl: './chatbot-preview.component.html'
})
export class ChatbotPreviewComponent implements OnInit {

  @Input() hideActions = false
  @Input() color: ThemePalette

  chatbotUuid?: string
  loader?: Observable<ChatbotDef>
  chatbot?: ChatbotDef
  settingDetails = false

  constructor(
    readonly api: ApiService,
    readonly activatedRoute: ActivatedRoute,
    readonly router: Router,
  ) {}

  ngOnInit(): void {
    this.chatbotUuid = this.activatedRoute.snapshot.params['chatbotUuid']
    this.loader = this.api.getChatbot(this.chatbotUuid!)
  }

  protected readonly Object = Object;
}


